import React from 'react'
import { Link } from 'react-router-dom'

const NoMatch = (props) => {
  return (
    <div className="d-f fd-c ai-c jc-c py-1">
      <h3>Sorry, we couldn’t find what you were looking for ☹️</h3>

      <Link className="tds-btn tds-btn--outline-interaction mt-2" to="/">
        Go to Webhooks
      </Link>
    </div>
  )
}

export default NoMatch
